import { render, staticRenderFns } from "./ApplicantProjectTab.vue?vue&type=template&id=1528274d&"
import script from "./ApplicantProjectTab.vue?vue&type=script&lang=js&"
export * from "./ApplicantProjectTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports